import request from '~/utils/http';
// 我的产品
export function getProductCenter(sendData) {
  return request({
    url: 'api/Product/GetList',
    method: "post",
    data: sendData
  })
}
// 报关商品查询
export function getQueryCustomsProduct(sendData) {
  return request({
    url: 'api/Product/QueryCustomsProduct',
    method: "post",
    data: sendData
  })
}
